import {Component} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {GenericChartComponent} from '../generic-chart/generic-chart.component';
import {FinanceDashboardChartType} from '../../enum/FinanceDashboardChartType';
import {SubmitToPieChartColorOptionsArray} from '../../constants/finance-dashboard-chart-options';

@Component({
    selector: 'app-gross-fare-by-submit-to',
    templateUrl: './gross-fare-by-submit-to.component.html',
    standalone: false
})

@AutoUnsubscribe()
export class GrossFareBySubmitToComponent extends GenericChartComponent {
  constructor() {
    super();
    this.chartConfiguration = {
      title: 'Gross Fare by Submit To',
      chartType: FinanceDashboardChartType.Pie,
      backGroundColor: SubmitToPieChartColorOptionsArray,
      borderColor: SubmitToPieChartColorOptionsArray,
    };
  }
}